import React from 'react'
import { Card, CardBody, CardTitle, Row, Col, } from 'reactstrap'
import PropTypes from 'prop-types'
/*
  ASP.Net Core Error Messages are ValidationProblemDetails objects like this:
    {
      "type": "https://tools.ietf.org/html/rfc7231#section-6.5.1",
      "title": "One or more validation errors occurred.",
      "status": 400,
      "traceId": "|7fb5e16a-4c8f23bbfc974667.",
      "errors": {
        "": [
          "A non-empty request body is required."
        ]
      }
    }
*/

const ProgramSearchError = ({ errorObj = null, }) => {
  var errorMarkup = []
  if (errorObj) {
    if (errorObj.errors){
      var keys = Object.keys(errorObj.errors)
      keys.map((k) => {
        errorMarkup.push(
          <>
            <Col xs={12}><b>{k}:</b> {errorObj.errors[k]}</Col>
          </>
        )
      })
    }
  } else {
    errorMarkup.push(<Col>An error occurred during your search.</Col>)
  }
  return <Card>
    <CardBody>
      <CardTitle tag={'h3'}>
        An error occurred performing your search:
      </CardTitle>
      {
        errorMarkup.map((e, idx) =>{
          return <Row key={`err-${idx}`}>{e}</Row>
        }) 
      }
      <Row>
        <Col>
          <p>If the error persists, please contact support at {process.env.REACT_APP_SUPPORT_EMAIL}</p>
        </Col>
      </Row>
    </CardBody>
  </Card>
}
ProgramSearchError.propTypes = {
  errorObj: PropTypes.oneOfType([ PropTypes.object, PropTypes.string , ]),
}

export default ProgramSearchError